/**
 * Deep-link para abrir o detalhe de uma NotificacaoEvento (não a lista vazia).
 * A página destino lê `?notificacaoId=` e abre o sheet.
 */
export function buildNotificacaoDeepLink(
  perfil: string | null | undefined,
  notificacaoId: string,
): string {
  const id = encodeURIComponent(notificacaoId);
  const p = String(perfil || '').toUpperCase();
  if (p === 'PROFESSOR') return `/professor/comunicados?notificacaoId=${id}`;
  if (p === 'MUNICIPAL') return `/municipal/comunicados?notificacaoId=${id}`;
  if (p === 'ESCOLA' || p === 'ADMIN' || p === 'REDE' || p === 'ESTADUAL') {
    return `/admin/comunicados?notificacaoId=${id}`;
  }
  return `/responsavel/notificacoes?notificacaoId=${id}`;
}

/** Fallback no SW / FCM quando o backend já manda `url`. */
export function buildNotificacaoDeepLinkFromPushData(data: {
  url?: string;
  targetPath?: string;
  notificacaoId?: string;
  responsavelId?: string;
  tipoNotificacao?: string;
}): string {
  if (data.url) return data.url;
  if (data.targetPath) return data.targetPath;
  const id = data.notificacaoId;
  if (!id) {
    if (String(data.tipoNotificacao || '').toUpperCase() === 'COMUNICADO') {
      return data.responsavelId ? '/responsavel/comunicados' : '/professor/comunicados';
    }
    return data.responsavelId ? '/responsavel/notificacoes' : '/professor/dashboard';
  }
  if (data.responsavelId) {
    return `/responsavel/notificacoes?notificacaoId=${encodeURIComponent(id)}`;
  }
  return `/professor/comunicados?notificacaoId=${encodeURIComponent(id)}`;
}
